"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function extractBook(_a) {
    var author = _a.author, description = _a.description, id = _a.id, image = _a.image, isbn = _a.isbn, name = _a.name, price = _a.price, publisher = _a.publisher, salesDate = _a.salesDate, url = _a.url;
    return { author: author, description: description, id: id, image: image, isbn: isbn, name: name, price: price, publisher: publisher, salesDate: salesDate, url: url };
}
exports.extractBook = extractBook;
function convertCountryIntoBookStoreUrl(country) {
    // country is ISO-3166-1 country code of 2 letters.
    return country === "JP"
        ? "https://books.rakuten.co.jp/book/computer/"
        : "https://www.betterworldbooks.com/computer-books-technology-books-H817.aspx";
}
exports.convertCountryIntoBookStoreUrl = convertCountryIntoBookStoreUrl;
//# sourceMappingURL=book.js.map


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/domain/book.js
// module id = 148
// module chunks = 0